import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {GeoLibService} from "../../services/geoLib/geo-lib.service";
import {MapPosition} from "../../models/MapPosition";
import {MeasurementService} from "../../services/measurementAdapter/measurement.service";
import {ItemManagerService} from "../../services/itemManager/item-manager.service";
import {debounceTime} from "rxjs/operators";
import {Item} from "../../models/Item";

@Component({
  selector: 'app-global-measurement',
  templateUrl: './global-measurement.component.html',
  styleUrls: ['./global-measurement.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GlobalMeasurementComponent implements OnInit {

  public Yiit = Yiit;
  public isFeetMeasurement = false;
  public measurementImperialHint = null;
  public measurementMetersHint = null;

  constructor(
    private geocoder: GeoLibService,
    private cd: ChangeDetectorRef,
    private measurementService: MeasurementService,
    private im:ItemManagerService
  ) { }

  ngOnInit() {
    // navigator.geolocation.getCurrentPosition(this.successGeolocation.bind(this), this.errorGeolocation.bind(this));
    this.setDefaultMeasurement();

      let subscribe = this.im.itemsList.pipe(debounceTime(500)).subscribe((list)=>{
        for (let i in list){
          if (!list.hasOwnProperty(i)){
            continue;
          }
          if(this.isFeetMeasurement){
            this.setMeasurement(true);
          }

          subscribe.unsubscribe();
          this.cd.detectChanges();
        }
      });

      // this.im.itemAdded$.pipe(debounceTime(500)).subscribe((item)=>{
      //   this.setSingleItemMeasurement(this.isFeetMeasurement, item);
      // });

    this.measurementImperialHint = this.encodeHtml(window['MEASUREMENT_IMPERIAL_HINT'] || '') ;
    this.measurementMetersHint = this.encodeHtml(window['MEASUREMENT_METERS_HINT'] || '');
  }

  private encodeHtml(string){
    let div = document.createElement('div');
    div.innerHTML = string;
    return div.innerText;
  }

  private setDefaultMeasurement(){
    this.isFeetMeasurement = window['EVENT_COUNTRY'].toLowerCase() == 'us' || window['CLIENT_MEASUREMENT'].toLowerCase() === 'imperial';
    this.measurementService.isFeetMeasurement = this.isFeetMeasurement;
    this.cd.detectChanges();
  }



  /**
   *
   * @param flag - if true set imperial else set metric
   */
  private setMeasurement(flag){
    let list = this.im.getAllItems();
    if (flag){
      list.forEach((item)=>{
        if (this.measurementService.hasMeasurement(item) && this.measurementService.getNextMeasurementSystemName(item).toLowerCase() === 'imperial'){
          this.measurementService.changeMeasurement(item);
        }
      })
    }
    else{
      list.forEach((item)=>{
        if (this.measurementService.hasMeasurement(item) && this.measurementService.getNextMeasurementSystemName(item).toLowerCase() === 'metric'){
          this.measurementService.changeMeasurement(item);
        }
      })
    }
    // this.cd.detectChanges();
  }

  public measurementOnChange(flag){
    this.isFeetMeasurement = flag;
    this.measurementService.isFeetMeasurement = flag;
    this.setMeasurement(flag);
    this.cd.detectChanges();
  }

}
